/**
 * 投诉提醒
 */
import dayjs from 'dayjs';
import { dailyShowCheck, WarnDialogConfig } from '@/common-components/warn-dialog';
import globalStore from '@/stores';
import commonReport from '@/common/common-report';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import AccountSelect from '@/components/AccountSelect';
import { hasFeatureFlag, hasPurview, hasRole } from '@/services';
import { getComplaintList } from './api';

export const getComplaintNoticeDialogConfig = async (): Promise<WarnDialogConfig | null> => {
  if (!hasPurview(96)) {
    return null;
  }
  // 运营人员根据灰度开关展示
  if (hasRole(108) && !hasFeatureFlag('is_op_show_complain')) {
    return null;
  }
  const res: any = await getComplaintList({
    data: {
      agency_uid_list: AccountSelect.getAgencyList({ onlyValid: true }).map((v) => v.agency_uid),
      page: 1,
      page_size: 999,
    },
  }, false);
  const total = res?.data?.conf?.total_num || 0;
  // 有投放
  if (total) {
    const reportUserBehavior = (behavior: string) => {
      const data = {
        behavior,
        page1: '概览',
        page2: '投诉提醒弹窗',
        page3: '',
      };
      reportUserBehaviorCgi({ data });
    };
    const config: WarnDialogConfig = {
      viewConfig: {
        saveKey: 'complaint_notice',
        saveValue: dayjs().format('YYYY-MM-DD'),
        showCheck: dailyShowCheck,
        showCallback: () => {
          reportUserBehavior('投诉提醒弹窗-展示');
          commonReport.reportAction('complaint-notice-warn.show');
        },
        showNextAfterClose: true,
      },
      useNewUI: false,
      type: 'normal',
      className: 'spaui-dialog-confirm-normal',
      headerStyle: { border: 'none' },
      footerStyle: { border: 'none' },
      iconType: 'remind',
      title: '消费者投诉提醒',
      closeButton: true,
      cancelButton: false,
      handleSubmit: () => {
        reportUserBehavior('投诉提醒弹窗-点击');
        globalStore.history.push('/agency/complaint/list');
      },
      submitLabel: '查看投诉单信息',
      content: <div>您负责的广告主有待处理的用户投诉单据，请尽快督促广告主登上 【微信商户后台】<a href="https://pay.weixin.qq.com" target="_blank" rel="noreferrer">https://pay.weixin.qq.com</a> -&gt;【账户中心】-&gt;【消费者投诉】处理相关投诉，超过3日会进行账户及保证金处罚
        <br />
        <br />
        如有疑问，参考<a href="https://doc.weixin.qq.com/doc/w3_AasAcwbtAHcRdhHEqYhQGeujO8uUN?scode=AJEAIQdfAAowq24twtAXgAHAafAIQ" target="_blank" rel="noreferrer">消费者投诉预警能力FAQ</a>
        <br />
        如仍无法解决，可联系行业经理/渠道经理反馈。
      </div>,
      submitButtonProps: {
        'data-report': 'complaint-notice-warn.submit',
      },
    };
    return config;
  }
  return null;
};
